import { defineMessages } from 'react-intl';

export const messages: {
	fpsInlineRovoChatTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	fpsInlineRovoChatTitle: {
		id: 'search-page.relay.fps-inline-rovo-chat.title',
		defaultMessage: 'Dive deeper into this topic with Rovo',
		description:
			'Title shown above the inline Rovo chat input box in full-page search results, inviting the user to continue exploring their search topic with Rovo.',
	},
});
